import { createContext } from "react";
import { THEME_LIGHT } from "./themeConstants";

// Split out from ThemeProvider so a module that only reads the value doesn't
// drag the provider in with it.
//
// The default value stands in for "nothing mounted a provider above me". It
// reports light and its setters are inert, so a component rendered outside the
// tree — most often a widget mounted on its own in a unit test — renders
// normally instead of blowing up on a destructure of undefined. `isFallback`
// lets anything that genuinely needs a real provider notice it hasn't got one.
export const FALLBACK_THEME_VALUE = {
    theme: THEME_LIGHT,
    resolvedTheme: THEME_LIGHT,
    isDark: false,
    setTheme: () => {},
    toggleTheme: () => {},
    // Returns the unregister callback the real one does, so a caller can always
    // just return it from an effect.
    registerUnthemedPage: () => () => {},
    isFallback: true,
};

export const ThemeContext = createContext(FALLBACK_THEME_VALUE);
